import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activityfooter',
  templateUrl: './activityfooter.component.html',
  styleUrls: ['./activityfooter.component.css']
})
export class ActivityfooterComponent implements OnInit {

  @Input() mainBO: any = {};

  constructor() { }

  ngOnInit() {
  }

}
